<template>
  <div>
    <Navigation />
    <section class="section__container top__container blog__details">
      <h1 class="center__text">POLITIQUE DE PROTECTION DES DONNÉES PERSONNELLES</h1>
      <p class="center__text title">www.servicesms.sn</p>
      
      <p>
        Cette politique de confidentialité s'applique à l'ensemble de la plateforme éditée par la société SERVICES-SMS,
        dont le siège social est situé à Ouakam/Dakar - N.I.N.E.A : 008960230 et immatriculée au Registre du Commerce
        sous le numéro SN.DKR.2021. A.2087, représentée par SYLLA Harouna en tant que Président. Cela inclut notamment
        la plateforme accessible à l'adresse URL : https://www.servicesms.sn.
  
      </p>
   
      <p>
        Lorsque vous utilisez la plateforme servicesms.sn ou nos solutions, vous nous fournissez des données, 
        dont certaines sont considérées comme des "données à caractère personnel". Conformément aux lois et
        règlements en vigueur, notamment la loi n° 2008-12 du 25 janvier 2008 sur la protection des données 
        à caractère personnel, notre politique de confidentialité explique :
      </p>
      <li>
       Quelles données personnelles sont collectées et comment elles sont recueillies, <br/></li>
      <li>
        Les raisons pour lesquelles ces données sont collectées,
      <br/></li>
      <li>
        Qui peut accéder à ces données et combien de temps elles seront conservées,
      <br/></li>
      <li>
        Qui est responsable du traitement des données,
      <br/></li>
      <li>
        La base juridique sur laquelle la collecte des données est fondée,
      <br/></li>
      <li>
        Les mesures de protection mises en place pour assurer la sécurité de vos données,
      <br/></li>
       <li>
        Les droits dont vous disposez en ce qui concerne vos données.
      <br/></li>

      <h3>1. Identité du responsable de traitement</h3>
      <p>
        La société SERVICES-SMS, dont le siège social est situé à Ouakam/Dakar et immatriculée 
        au registre du commerce sous le numéro SN.DKR.2021.A.2087, est le responsable du traitement des données.
      </p>
      
      <h3>2. Finalités de traitement et bases légales</h3>
    
      <p>
        Les données que vous nous transmettez sont utilisées dans les buts suivants :</p>
        
      <li>
        La création de votre compte servicesms.sn suite à votre demande d'inscription à l'une de nos Solutions, 
        la gestion et le suivi de notre relation, notamment en tant que client si vous souscrivez à l'une de nos 
        Solutions, ainsi que pour assurer le bon fonctionnement des Solutions. Dans ce cas, le traitement est basé 
        sur l'exécution du contrat auquel vous avez souscrit.
      <br></li>
      <li>
        La réponse à vos demandes d'informations. Dans ce cas, le traitement est basé sur notre intérêt légitime
        à répondre à vos questions.
      <br/></li>

      <li>
        L'envoi d'informations relatives à votre compte et aux Solutions que vous utilisez. Dans ce cas, le traitement 
        est basé sur l'exécution du contrat auquel vous avez souscrit.
      <br/></li>
      <li>
        La lutte contre la fraude. Dans ce cas, le traitement est basé sur notre intérêt légitime à identifier les fraudeurs
        qui utilisent nos Solutions de manière illégale, en collectant les adresses IP et en bloquant potentiellement
        leur accès au niveau de l'application ou du pare-feu.
      <br/></li>
      <p>
        Les données "Web Analytics" sont collectées via des adresses IP par Google Analytics. 
        Elles nous permettent de mesurer l'audience de la plateforme, les consultations et les éventuelles erreurs
        afin d'améliorer l'expérience de navigation.
      </p>
      
      <h3>3. Catégorie des données collectées</h3>
     
      <p>
        Lorsque vous consultez la plateforme, nous pouvons collecter différents types de données, notamment :</p>

        <li>
          Les données transmises directement : les informations que vous nous fournissez en remplissant un formulaire, en utilisant notre chat, en nous contactant par e-mail ou en utilisant nos Solutions.
      </li>

      <li>
        Les données collectées automatiquement via les cookies pour obtenir des informations de type "web Analytics" liées à votre navigation.
      </li>
     
        <p>Voici la liste des données que nous recueillons : </p>
        <li>Données d'identité (nom et prénom).<br/></li>
        <li>Données professionnelles (nom et adresse de l'entreprise).<br/></li> 
        <li>Données de contact (numéro de téléphone, adresse e-mail). <br/></li>
        <li>Votre adresse IP.<br/></li> 
        <li>Données de connexion (cookies, adresse IP).<br/></li> 
        <li>Données transmises via les SMS envoyés à vos clients.<br/></li> 

        <p>Vous nous fournissez certaines de ces données lorsque :</p> 
        <li>Vous remplissez des formulaires de contact et d'inscription sur la plateforme.<br/></li> 
        <li>Vous utilisez les différents moyens de contact disponibles sur la plateforme, tels que le téléphone et l'e-mail.<br/></li> 
        <li>Vous envoyez une candidature à SERVICES-SMS via la plateforme.<br/></li> 
        <li>Vous naviguez sur la plateforme.<br/></li> 
        <li> Vous utilisez nos Solutions.<br/></li> 

     
        <h3>4. Destinataires</h3>
      <p>
        Nous sommes les principaux destinataires de vos données, dans le cadre du traitement de vos commandes
        et de la gestion de la relation client. Plus précisément, en interne, les destinataires sont les suivants :
        le service informatique, le service client et le service de communication.
      </p>
      <p>
        D'autres destinataires de vos données personnelles peuvent inclure, le cas échéant, nos prestataires de moyens
        de paiement ou de sécurisation des paiements, notre fournisseur d'hébergement, nos prestataires de livraison,
        ainsi que des prestataires de services tiers et des plateformes tierces.
      </p>
      <h3>5. Durée de conservation</h3>
      <p>
        Nous ne conservons pas vos données personnelles au-delà de la durée nécessaire pour atteindre la finalité pour laquelle elles ont été collectées.
      </p>
       <p>Concernant les données collectées dans le cadre de votre souscription à l'une de nos Solutions :</p>
      <li>
        Pendant toute la durée de notre relation commerciale et jusqu'à un maximum de 3 ans après la fin de notre relation 
        commerciale. Veuillez noter que certaines données de facturation doivent être conservées pour respecter nos obligations
        légales en matière de comptabilité. 
        <br/></li>
        <p>Concernant les données utilisées pour vous envoyer des informations sur nos produits :</p>
      <li>
        Si vous êtes l'un de nos clients, les données utilisées à des fins de prospection commerciale 
        seront conservées pendant un maximum de trois (3) ans après la fin de notre relation commerciale
         <br/></li>
    
      <li>
        Si vous êtes l'un de nos prospects, c'est-à-dire un non-client, vos données seront conservées
        pendant une période de trois (3) ans à compter de leur collecte ou du dernier contact émanant de votre part.
         <br/></li>
      <li>
        À la fin de cette période de trois (3) ans, nous vous contacterons pour savoir si vous souhaitez continuer
        à recevoir des sollicitations commerciales. En l'absence de réponse positive de votre part, nous nous engageons
        à supprimer ou archiver vos données. 
         <br/></li>
  
      <p>
        Concernant les données transmises via les SMS envoyés à vos clients par le biais de nos Solutions, le contenu
        des SMS est conservé pendant une durée maximale de six mois.
      </p>
      <h3>6. Sécurité et confidentialité des données personnelles</h3>
      <p>
        La société SERVICES-SMS s'engage à mettre en place les mesures de sécurité techniques et organisationnelles
        nécessaires pour assurer un niveau de sécurité approprié aux données personnelles confiées par le client.
        Tous nos employés sont conscients de l'importance de la sécurité de vos données.
      </p>
        <h3>7. Vos droits concernant vos données personnelles</h3>
      
        <p>En ce qui concerne le traitement de vos données, vous avez les droits suivants :</p>
       <li>Le droit d'accéder à vos données,<br/></li>
       <li>Le droit de rectifier vos données,<br/></li>
       <li>Le droit de limiter le traitement de vos données,<br/></li>
       <li>Le droit de supprimer vos données,<br/></li> 
       <li>Le droit de vous opposer au traitement de vos données,<br/></li>
       <li>Le droit de retirer votre consentement pour les traitements basés sur ce consentement,<br/></li> 
       <li>Le droit à la portabilité des données brutes que vous avez fournies à SERVICES-SMS,<br/></li>
       <p>L'utilisateur a également le droit de déposer une réclamation auprès de la CPD dont les coordonnées sont disponibles à l'adresse internet https://www.cdp.sn</p>

      <p>
        Afin de répondre à votre demande, nous aurons besoin de vérifier votre identité. 
        Par conséquent, nous pourrions vous demander une copie d'une pièce d'identité comportant
        votre signature. Veuillez également préciser l'adresse à laquelle vous souhaitez recevoir la réponse.
      </p>
      <p>
        Nous vous enverrons une réponse dans un délai maximum d'un (1) mois à compter de la réception de votre demande.
      </p>
      
      
    </section>
    <Footer/>
  </div>
</template>


<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
export default {
  components: {
    Navigation,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";

@media(min-width:64rem){
  .top__container{
  margin-top:10rem;
 }
}
</style>
